import { ReactElement } from 'react'
import { CheckboxList, List } from './CheckboxList'
import { CheckboxListWrapperI } from '../interfaces'

export const CheckboxListWrapper = (
  props: CheckboxListWrapperI
): ReactElement => {
  const { groupName, options, onChange } = props

  const handleOnChange = (selectedFilters: List) => {
    const selectedOptions = selectedFilters.filter((item) => item.active)
    onChange(groupName, selectedOptions)
  }

  return <CheckboxList list={options} onChange={handleOnChange} />
}
